import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { showModal, showNestedModal } from "../../features/modal/modalSlice";
import { BsCheck2 } from "react-icons/bs";
import { setDevamliAracInfoForDelete, setDevamliAraclarAldigiIsListeleme, setDevamliAraclarIsListesiListeleme, setDevamliAraclarKayitliArac, setDevamliAraclarSiraListesiListeleme, setSelectedDevamliArac } from "../../features/joblist/jobListSlice";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useState } from "react";
import { setSelectUserData } from "../../features/user/userSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    width: 100% !important;
    padding: 15px 10px;
    border-radius: 10px;
    margin: 10px 0px 0px 0px !important;
    position: relative;
    border: 1px solid var(--color-light);
    background-color: ${({ theme }) => theme.mainBgColor};
    display: flex;
    .checkbox {
      margin-right: 10px;
      cursor: pointer;
    }
    .checkContainer {
      margin-right: 10px;
      .checkBox {
        border: 1px solid ;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        cursor: pointer;
        .checkIcon {
          color: white;
          font-size: 15px;
        }
      }
    }
    .row {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
      gap: 15px;
      text-align: left;
      position: relative;
      .col {
        p {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-xl);
          text-decoration: underline;
          margin-bottom: 10px;
          color: ${({ theme }) => theme.mainTextColor} !important; 
        }
        .info {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          margin-block: 7px;
          color: ${({ theme }) => theme.mainTextColor} !important;
          
        }
        .show-trucks{
          color: var(--color-main);
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-decoration: underline;
          cursor: pointer;
        }
        .daily{
          color: var(--color-main);
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 20px;
        right: 10px;
        background-color: var(--color-light);
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: ${({ theme }) => theme.mainTextColor};
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
  .selected-check {
    background-color: var(--color-main);
    border: 1px solid var(--color-main) !important;
  }
  .invite {
    text-decoration: underline;
    cursor: pointer;
    color: var(--color-main) !important;
  }

  @media (max-width: 1150px){
    .row{
      grid-template-columns: repeat(4, 1fr) !important;
    }
  }

  @media (max-width: 700px){
    .row{
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
`;

const DevamliAraclarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const { selectedDevamliArac } = useSelector((state) => state.jobList);
  const dispatch = useDispatch();
  const [isMoreActive, setIsMoreActive] = useState(null)

  const toggleMore = (item) => {
    if (isMoreActive === item) {
      setIsMoreActive(null);
    } else {
      setIsMoreActive(item);
    }
  };

  return (
    <Container  theme={theme}>
      <div className="container">
        <div className="row">
          <div className="col">
            <p>Sürücü</p>
            <div onClick={() => {dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(data?.phoneNumber)) }} className="info invite">{data?.firstLastName}</div>
            <div className="info">{data?.phoneNumber}</div>
            <div className="info">
              {moment(data?.createdDate).format("lll", "tr")}
            </div>
          </div>
          {data?.devamliAraclarPlakas?.length > 1 
            ?
            <div className="col">
              <p>Araç</p>
              <span onClick={()=> { dispatch(showNestedModal("devamliAraclarAracListeleme")); dispatch(setDevamliAraclarKayitliArac(data?.devamliAraclarPlakas)) }} className="show-trucks">{data?.devamliAraclarPlakas?.length} Araç</span>
            </div>
            :
            <div className="col">
              <p>Araç</p>
              <div className="info">
                {data?.devamliAraclarPlakas?.[0]?.truckType}{" "}{data?.devamliAraclarPlakas?.[0]?.caseType && `/ ${data?.devamliAraclarPlakas?.[0]?.caseType}`}{" "}
              </div>
              <div className="info">
                {data?.devamliAraclarPlakas?.[0]?.plate}
              </div>
              <div className="info">
                {data?.devamliAraclarPlakas?.[0]?.groundType}
              </div>
            </div>
          }

          <div className="col">
            <p>Referans</p>
            <div className="info">
              {data?.isContinueVehicle === true
                ? "Devamlı Aracım"
                : "Misafir Araç"}
            </div>
            <div className="info">
              {data?.isReferenceDriver === true
                ? "Referansıyım"
                : "Referansı Değilim"}
            </div>
          </div>

          <div className="col">
            <p>Üyelik ve Erişim İzni</p>
            <div className="info">
              {data?.isKamyoonMember === false ||
              data?.isKamyoonMember === null ? (
                <span onClick={() => dispatch(showModal("DevamliAraclarDavetModal")) } className="invite">
                  Kamyoon'a Üye Değil
                </span>
              ) : (
                "Kamyoon'a Üye"
              )}
            </div>
            <div className="info">
              {data?.isKamyoonAccessPermission === false ||
              data?.isKamyoonAccessPermission === null ? (
                <span className="invite">Erişim İzni Yok</span>
              ) : (
                "Erişim İzni Var"
              )}
            </div>
          </div>

          <div className="col">
            <p>Sıra Listesi</p>
            {data?.allGunlukAracListesi?.length === 0 ? <span>-</span> : <span onClick={()=>{dispatch(showModal("devamliAraclarSiraListeleme")); dispatch(setDevamliAraclarSiraListesiListeleme(data?.allGunlukAracListesi))}} className="daily">{data?.allGunlukAracListesi?.length} adet</span>}
          </div>

          <div className="col">
            <p>İş Listesi</p>
            {data?.filterGunlukAracListesi?.length === 0 ? <span>-</span> :<span onClick={()=>{dispatch(showModal("devamliAraclarIsListeleme")); dispatch(setDevamliAraclarIsListesiListeleme(data?.filterGunlukAracListesi))}} className="daily">{data?.filterGunlukAracListesi?.length} adet</span> } 
          </div>

          <div className="col">
            <p>Aldığı İşler</p>
            {data?.personalLoads?.length === 0 ? <span>-</span> :<span onClick={()=>{dispatch(showModal("devamliAraclarAldigiIsListeleme")); dispatch(setDevamliAraclarAldigiIsListeleme(data?.personalLoads))}} className="daily">{data?.personalLoads?.length} adet</span> } 
          </div>

          <div onClick={(e)=> {e.stopPropagation(e); dispatch(showModal("updateDevamliArac")); dispatch(setSelectedDevamliArac(data)) }} className="more"><MdOutlineMoreHoriz/></div>
        </div>
      </div>
    </Container>
  );
};

export default DevamliAraclarContainer;
